// assets/buy-now.js
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('button[id^="buy-now-"]');
  if (!btn) return;

  // sekcja produktu (ten wrapper z data-section)
  const section = btn.closest('[data-section]');
  if (!section) return;

  // główny formularz "Dodaj do koszyka"
  const productForm = section.querySelector('product-form form[action="/cart/add"]');
  if (!productForm) return;

  // (opcjonalnie) sprawdź checkbox regulaminu, jeżeli masz go na stronie
  const terms =
    section.querySelector('input[type="checkbox"][name*="terms"]') ||
    section.querySelector('input[type="checkbox"][id*="terms"]');
  if (terms && !terms.checked) {
    alert('Zaznacz akceptację regulaminu sklepu.');
    return;
  }

  // wybrany wariant + ilość
  const idInput = productForm.querySelector('input[name="id"]');
  const qtyInput = section.querySelector('input[name="quantity"]');
  const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

  if (!idInput || !idInput.value) return;

  btn.disabled = true;

  try {
    // dodaj produkt do koszyka przez AJAX
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: idInput.value, quantity })
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err?.description || 'Nie udało się dodać produktu do koszyka.');
    }

    // od razu do checkoutu
    window.location.href = '/checkout';
  } catch (err) {
    alert(err.message || 'Wystąpił błąd. Spróbuj ponownie.');
    btn.disabled = false;
  }
});
